import React from 'react';

interface Props {
  className?: string;
  children: any;
}

export default (props: Props) => (
  <div className={`Box ${props.className || ''}`}>{props.children}</div>
);
